export default "__VITE_ASSET__b8bfe15d__"